export default [
  {
    id: '1',
    value: '梳理业务/企业战略、方向'
  },
  {
    id: '2',
    value: '走进创新企业游学交流'
  },
  {
    id: '3',
    value: '找供应链、找好产品'
  },
  {
    id: '4',
    value: '找渠道或流量方卖货'
  },
  {
    id: '5',
    value: '想实现私域变现'
  },
  {
    id: '6',
    value: '企业组织能力升级'
  },
  {
    id: '7',
    value: '企业数字化转型'
  },
  {
    id: '8',
    value: '企业其他内训需求'
  }
];
